import Fetcher from "./Common/Fetch";
import { addLocale } from 'primereact/api';

export const DEFAULT_LOT_IMAGE = "/Content/images/defaultLotImage.png"; 
export const LOT_DETAILS_URL = "/TradeLot/View/";
export const COMPANY_LOTS_URL = "/Category/Details?companyId=";
export const DATE_TIME_FORMAT = "DD.MM.YYYY в HH:mm";

class SettingsData {
    Theme: string;
    Payment: {
        CommissionSalesOnArt: number,
        CommissionSalesOnRealty: number,
        Commission: number
    }
}

class Settings {
    constructor() {
    }

    Data: SettingsData
    IsLoaded: boolean


    Init(callback) {

        this.AddLocale();
        this.GetSettingsFromServer(callback);
    }

    AddLocale() {
        const calendarLocale = {
            firstDayOfWeek: 1,
            showMonthAfterYear: true,
            dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
            dayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
            dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
            monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            today: 'Сегодня',
            clear: 'Очистить'
        }

        addLocale('ru', calendarLocale);
    }

    GetSettingsFromServer(callback) {
        if (!this.IsLoaded)
            Fetcher('/Settings/GetSettings/', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    this.Data = data;
                    this.IsLoaded = true;
                    callback(true);
                });
    }

}
export default new Settings();